<app-spinner></app-spinner>

<div class="mx-auto" style="width: 82%">


    <div class="fs-5 mb-3">
      <span class="pointer" [ngClass]="{'fw-bold text-decoration-underline': this.selectedcategory === 'industry'}"
            (click)="this.selectedcategory = 'industry'">Branche</span>
      <span> | </span>
      <span class="pointer" [ngClass]="{'fw-bold text-decoration-underline': this.selectedcategory === 'contract_type'}"
            (click)="this.selectedcategory = 'contract_type'">Vertragsart</span>
      <span> | </span>
      <span class="pointer" [ngClass]="{'fw-bold text-decoration-underline': this.selectedcategory === 'timemodel'}"
            (click)="this.selectedcategory = 'timemodel'">Zeitmodel</span>
      <span> | </span>
      <span class="pointer" [ngClass]="{'fw-bold text-decoration-underline': this.selectedcategory === 'remote'}"
            (click)="this.selectedcategory = 'remote'">Remote</span>

      <div class="text-end">
        <a routerLink="/admin/filterform/create/">
          <button type="button" class="btn btn-primary mb-5">Filter Erstellen</button>
        </a>
      </div>

    </div>

    <table class="table top">
      <thead>
      <tr>
        <th scope="col" class="pointer" (click)="this.sortTablebyColum('id')">
          ID <i *ngIf="this.lastsort === 'id'"
                [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                class="bi"></i>
        </th>

        <th scope="col" class="pointer" (click)="this.sortTablebyColum('displayname')">
          Name <i *ngIf="this.lastsort === 'displayname'"
                  [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                  class="bi"></i>
        </th>

        <th scope="col" class="pointer" (click)="this.sortTablebyColum('filtername')">
          Filtername <i *ngIf="this.lastsort === 'filtername'"
                        [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                        class="bi"></i>
        </th>

        <th scope="col" class="pointer" (click)="this.sortTablebyColum('active')">Aktiv
          <i *ngIf="this.lastsort === 'active'"
             [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
             class="bi"></i>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr (click)="Helper.TableSelect($event)" *ngFor="let filtervalue of this.getFilterValues(selectedcategory)">
        <td>{{ filtervalue.id }}</td>
        <td>{{ filtervalue.displayname }}</td>
        <td>{{ filtervalue.filtername }}</td>
        <td>
          <input type="checkbox" name="" id="checkbox{{filtervalue.id}}" class="checkbox-slider"
                 (click)="this.changeStatus($event,filtervalue.id)" [checked]="filtervalue.active">
          <label for="checkbox{{filtervalue.id}}"></label>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
